export default function openai() {
  const openaiElements = document.querySelectorAll('.openai');

  // Track which elements are open
  let openElements = new Set();

  openaiElements.forEach((element, index) => {
    const title = element.querySelector('.openai__title');
    const content = element.querySelector('.openai__content');

    if (!title || !content) {
      console.warn('OpenAI element missing required title or content elements');
      return;
    }

    // Initialize first element as open, others as closed

    element.setAttribute('data-open', 'false');
    title.setAttribute('aria-expanded', 'false');

    // Add click handler to title
    title.addEventListener('click', (e) => {
      e.preventDefault();
      toggleOpenAI(element);
    });

    // Add mouse click handler to content
    content.addEventListener('click', (e) => {
      if (e.detail > 0) {
        toggleOpenAI(element);
      }
    });

    // Add keyboard support
    title.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleOpenAI(element);
      }
    });

    // Make title focusable
    title.setAttribute('tabindex', '0');
    title.setAttribute('role', 'button');
    title.setAttribute('aria-controls', content.id || `openai-content-${Math.random().toString(36).substr(2, 9)}`);

    // Set content id if not already set
    if (!content.id) {
      content.id = title.getAttribute('aria-controls');
    }
  });

  function toggleOpenAI(element) {
    const title = element.querySelector('.openai__title');
    const isOpen = element.getAttribute('data-open') === 'true';

    if (isOpen) {
      // Close
      element.setAttribute('data-open', 'false');
      element.removeAttribute('open');
      title.setAttribute('aria-expanded', 'false');
      openElements.delete(element);
    } else {
      // Open
      element.setAttribute('data-open', 'true');
      element.setAttribute('open', '');
      title.setAttribute('aria-expanded', 'true');
      openElements.add(element);
    }
  }
}
